import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { ContentSpacing, breakpoint } from 'elc-base-theme';
import { Subtitle1 } from 'elc-typography';
import { ProductPriceTheme } from '../../../theme/default-theme';

export interface IProductPriceRangeRowWrapper {
    className?: string;
}

export interface IProductPriceRangeRow extends IProductPriceRangeRowWrapper {
    priceRange: {
        formattedMinPrice: string;
        formattedMaxPrice: string;
    };
}

const ProductPriceRangeRowWrapper = styled.div`
    margin: ${ContentSpacing.space16} 0;
    ${breakpoint('desktop')`
        margin: 0;
    `};
`;

const ProductPriceRange = styled(Subtitle1)`
    ${ProductPriceTheme};
`;

export const ProductPriceRangeRow = observer((props: IProductPriceRangeRow) => {
    const productPriceRangeRowWrapperClassNames = classnames(
        'elc-product-price-range-row-wrapper',
        'js-product-price-range-row-wrapper'
    );

    const productPriceRangeClassNames = classnames(
        'elc-product-price-range',
        'js-product-price-range'
    );

    const { priceRange } = props;

    return (
        <ProductPriceRangeRowWrapper className={productPriceRangeRowWrapperClassNames}>
            <ProductPriceRange className={productPriceRangeClassNames}>
                {priceRange.formattedMinPrice} - {priceRange.formattedMaxPrice}
            </ProductPriceRange>
        </ProductPriceRangeRowWrapper>
    );
});
